import { useState, useEffect } from 'react'
import './styles.css'

function MobileMenuButton({ onToggle, isOpen }) {
  return (
    <button
      className={`mobile-menu-button ${isOpen ? 'mobile-menu-button--open' : ''}`}
      onClick={onToggle}
      aria-label="Toggle menu"
    >
      <span className="mobile-menu-line"></span>
      <span className="mobile-menu-line"></span>
      <span className="mobile-menu-line"></span>
    </button>
  )
}

export default MobileMenuButton
